module.exports = __webpack_public_path__ + "static/media/full_story_big.90936808.png";